
// Convert FormGroup to FormData
import {FormArray, FormControl, FormGroup} from "@angular/forms";

export function convertNestedFormGroupToFormData(formGroup: FormGroup | FormArray, formData: FormData = new FormData(), parentKey: string = ''): FormData {
    Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);
        const fullKey = parentKey ? `${parentKey}.${key}` : key;

        if (control instanceof FormControl) {
            const controlValue = control.value;
            if (controlValue instanceof File) {
                formData.append(fullKey, controlValue);
            } else if (controlValue !== null && controlValue !== undefined) {
                formData.append(fullKey, controlValue.toString());
            }
        }

        else if (control instanceof FormGroup) {
            convertNestedFormGroupToFormData(control, formData, fullKey);
        }

        else if (control instanceof FormArray) {
            control.controls.forEach((itemControl, index) => {
                const arrayKey = `${fullKey}[${index}]`;

                if (itemControl instanceof FormGroup) {
                    convertNestedFormGroupToFormData(itemControl, formData, arrayKey);
                }
                else if (itemControl instanceof FormControl) {
                    const itemValue = itemControl.value;
                    if (itemValue instanceof File) {
                        formData.append(arrayKey, itemValue);
                    } else if (itemValue !== null && itemValue !== undefined) {
                        formData.append(arrayKey, itemValue.toString());
                    }
                }
            });
        }
    });

    return formData;
}